module.exports = __webpack_public_path__ + "img/LB.4eede547.svg";